import Transformer from './../transformer'
import { assetURL } from '@/utils'

const notificationSinisterModify = ({note = ''}) => {
  return note && note.includes('-->') ? note.replaceAll('#', '\n • ') : note
}

export default class BinnacleTransformer extends Transformer {
  static fetch(binnacle) {
    const { user_data } = binnacle
    const userData = {
      name: `${user_data.first_name} ${user_data.last_name} ${user_data.mothers_last_name}`,
      avatar: assetURL(user_data.photo),
      roleCode: user_data.role_code,
      username: user_data.username,
    }
    return {
      id: binnacle.id,
      affectedId: binnacle.affected,
      // note: binnacle.note,
      note: notificationSinisterModify(binnacle),
      substatus: binnacle.substatus,
      addDate: binnacle.add_date,
      userData,
    }
  }

  static fetchCollection(binnacles) {
    const collection = binnacles.map(this.fetch)
    collection.sort((be1, be2) => be1.addDate < be2.addDate)
    return collection
  }

  static send(binnacle) {
    return {
      user: binnacle.user,
      note: binnacle.note,
      mentioned_users: binnacle.mentionedUsers
    }
  }
}



// WEBPACK FOOTER //
// ./src/transformers/sinister/binnacle.js